import React from 'react'

import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import HeadTag from '@components/UI/HeadTag'
import { BillingTypes } from '@enums'
import { selectBillingType } from '@store/router'

export const BillingHeaderTag: React.FC = () => {
  const location = useLocation()
  const billingType = useSelector(() => selectBillingType(location))

  const headerId =
    billingType === BillingTypes.Campaigns
      ? 'core.text.billing.campaignBillingHistory'
      : 'core.text.purchases.contentLibraryPurchases'
  return <HeadTag id={headerId} />
}

export default BillingHeaderTag
